import { render, staticRenderFns } from "./IconFaceLaugh.vue?vue&type=template&id=d273d736&"
import script from "./IconFaceLaugh.vue?vue&type=script&lang=js&"
export * from "./IconFaceLaugh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports